module.exports = __webpack_public_path__ + "static/media/bf9.2a9c6eed.png";